import { ThemingUtils } from "ui-common";
import { embeddableAgent } from "../embeddable/services/embeddable-agent";

const commonRoutine = () => {
  // For Full dev build:
  // Initiate Embeddable Agent during bootstrap instead of lazily load it via Embeds components rendering afterwards.
  // This allows Embeds dev build also works for no-code fashion.
  import(`../embeddable`);

  ThemingUtils.initTheming();

  if (!window.onSearchStoreReady) {
    Object.defineProperty(window, 'onSearchStoreReady', {
      set: (callback) => {
        embeddableAgent.onReady(callback);

        return callback;
      },

      configurable: true,
    });
  }
};

export default commonRoutine;